import { render } from "./dropdown.vue?vue&type=template&id=96a408c8&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=ts"
export * from "./dropdown.vue?vue&type=script&lang=ts"

import "./dropdown.vue?vue&type=style&index=0&id=96a408c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96a408c8"

export default script